import { EasingFunction, CircleEase } from '@babylonjs/core/Animations/easing';
import orderBy from 'lodash/orderBy';

import { UiSystem } from '../System/uiSystem'
import { Animation } from '../System/animation'
import { Player } from '../Player/player';
import { minSize, maxSize } from '../Objects/star';
import { RealPlayer } from '../Player/realPlayer';
import { ui_group, ui_panel, ui_control } from './group';
import { ui_text, ui_back } from './node';
import { TileMap } from '../Map/tileMap';
import { MAX_LEVEL } from '../Map/localMap';
import { MinimapUI } from './minimap';

export class PlayUI extends MinimapUI {

    system: UiSystem;
    realPlayer: RealPlayer;
    tileMap: TileMap;
    fontSize = 20;
    showAnimation: Animation;
    shineAnimation: Animation;
    checkAnimation: Animation;
    curve: EasingFunction;

    constructor(system: UiSystem, realPlayer: RealPlayer, tileMap: TileMap) {
        super(system, realPlayer, tileMap);
        this.system = system;
        this.realPlayer = realPlayer;
        this.tileMap = tileMap;
        this.showAnimation = new Animation(system.animationManager);
        this.shineAnimation = new Animation(system.animationManager);
        this.checkAnimation = new Animation(system.animationManager, );
        this.curve = new CircleEase();

        this.addPlayerStat();
        this.addSupernovaLayer();
        // this.addPlayerList();
        this.hide();
    }

    statLayout: ui_control;
    sizeProgress: ui_back;
    width = 200;
    addPlayerStat() {
        this.statLayout = new ui_control(this.system, { x: 0, y: 0 }, { width: this.width, height: 60 });
        this.statLayout.setScreenPosition({ left: this.screenMargin, bottom: this.screenMargin })
        this.statLayout.addBack({ x: 0, y: 30 }, { width: this.width, height: 20, float: 'left', opacity: 0.3 });
        this.sizeProgress = this.statLayout.addBack({ x: 0, y: 15 }, { width: this.width, height: 20, float: 'left' });
        this.sizeText = this.statLayout.addText('Level: 2', { x: 0, y: -15 }, { fontSize: this.fontSize, height: 60, float: 'left' });
        this.sizeText.setBackgroundOpacity(0);
        // this.rankText = this.statLayout.addText('Rank: 5/100', { x: 0, y: -30 }, { fontSize: this.fontSize, float: 'left' });
    }

    listLayout: ui_group;
    player1: ui_text;
    player2: ui_text;
    player3: ui_text;
    player4: ui_text;
    player5: ui_text;
    addPlayerList() {
        this.listLayout = new ui_panel(this.system, {top: this.screenMargin, right: this.screenMargin}, { width: 250, height: 200 });
        this.listLayout.addText('Winners', { x: 0, y: -100 }, { fontSize: this.fontSize });
        this.player1 = this.listLayout.addText('', { x: 0, y: 60 }, { fontSize: this.fontSize, float: 'left' });
        this.player2 = this.listLayout.addText('', { x: 0, y: 80 }, { fontSize: this.fontSize, float: 'left' });
        this.player3 = this.listLayout.addText('', { x: 0, y: 100 }, { fontSize: this.fontSize, float: 'left' });
        this.player4 = this.listLayout.addText('', { x: 0, y: 120 }, { fontSize: this.fontSize, float: 'left' });
        this.player5 = this.listLayout.addText('', { x: 0, y: 140 }, { fontSize: this.fontSize, float:'left' });
    }

    supernovaLayout: ui_control;
    supernovaText: ui_text;
    addSupernovaLayer() {
        this.supernovaLayout = new ui_control(this.system, { x: 0, y: '-45%' }, { width: '100%', height: '10%' }, {});
        this.supernovaText = this.supernovaLayout.addText('1 level before supernova', { x: 0, y: 0 }, { fontSize: this.fontSize + 10 });
        this.supernovaLayout.hide();
    }

    getRanks(): Player[] {
        let playerArray = [];
        for (const key in this.tileMap.stars) {
            if (this.tileMap.stars.hasOwnProperty(key)) {
                const player = this.tileMap.stars[key];
                playerArray.push(player);
            }
        }
        let ranks = orderBy(playerArray, ['size'], ['desc'] );
        return ranks;
    }

    totalPlayers = 500;
    checkRanks() {
        // let ranks = this.getRanks();
        // let playerIndex = ranks.indexOf(this.realPlayer) + 1;
        // let perc = playerIndex/ranks.length;
        // let fakePlayerIndex = Math.round(perc * this.totalPlayers)
        let perc = (this.realPlayer.size - minSize) / (maxSize - minSize);
        
        // perc = Math.pow(perc, 0.8);
        let fakePlayerIndex = Math.round((1 - perc) * this.totalPlayers);
        this.rankText.setText('Your rank: ' + fakePlayerIndex + '/' + this.totalPlayers);
    }

    getPlayerSize() {
        let plSize = this.realPlayer.size;
        const playerGap = Math.max(plSize - minSize, 0);
        // const maxGap = maxSize - minSize;
        // const playerProg = playerGap / maxGap;
        // return playerProg * MAX_LEVEL;
        return playerGap * 10;
    }

    currentWidth = 0;
    currentSize = 0;
    checkPlayerSize() {
        let sizeAdjusted = this.getPlayerSize();
        let playerSize = Math.floor(sizeAdjusted);
        this.sizeText.setText('Level: ' + playerSize.toString());
        
        let width = Math.round((sizeAdjusted - playerSize) * this.width);
        if (width != this.currentWidth) { 
            this.sizeProgress.setWidth(width);
            this.currentWidth = width;
        }
        if (playerSize != this.currentSize) {
            this.shinePlayerSize();
            if (playerSize > this.currentSize) {
                // this.system.soundManager.play('levelUp');
                // > 5 to avoid showing at the beginning
                if ( playerSize > 5 && Math.round(playerSize / 5) == playerSize / 5 ) {
                    this.showLevelBeforeSupernova(MAX_LEVEL - playerSize);
                }
            } else {
                // this.system.soundManager.play('levelDown');
            }
            this.sizeProgress.setWidth(width);
            this.currentSize = playerSize;
        }
    }

    shinePlayerSize() {
        this.shineAnimation.simple(50, (count, perc) => {
            let easePerc = this.curve.ease(perc);
            let opacity = Math.min(easePerc, 1 - easePerc) * 2;
            this.sizeText.setBackgroundOpacity(opacity);
        }, () => {
            this.sizeText.setBackgroundOpacity(0);
        });
    }

    showLevelBeforeSupernova(level: number) {
        return;
        this.supernovaText.setText(level + ' level before supernova.');
        this.supernovaLayout.show();
        this.showAnimation.simple(100, (count, perc) => {
            let opacity = Math.min(perc * 2, 2 - perc * 2);
            this.supernovaLayout.setOpacity(opacity);
        }, () => {
            this.supernovaLayout.setOpacity(0);
            this.supernovaLayout.hide();
        });
    }

    setColor(color: string) {
        this.supernovaLayout.setColorAll(color);
        this.statLayout.setColorAll(color);
        // this.listLayout.setColorAll(color);

        this.sizeProgress.setColor(color);
        this.sizeProgress.setStyle({background: color});
        this.sizeText.setStyle({background: color});
    }

    show() {
        // this.listLayout.show();
        this.statLayout.show();
        // this.minimapLayout.show();
        this.setRealPlayerColor();
        this.totalPlayers = Math.round(Math.random() * 50 + 450);
        let sizeAdjusted = this.getPlayerSize();
        this.currentSize = Math.floor(sizeAdjusted);
        this.setColor(this.system.skyColorHex);
        this.shinePlayerSize();

        this.checkAnimation.interval(200, (count, perc) => {
            if (!this.realPlayer.isBlackHole) {
                // this.checkRanks();
                this.checkPlayerSize();
            } else {
                this.statLayout.hide();
            }
        });
    }

    hideAnim(callback?: Function) {
        this.checkAnimation.stop();
        this.setLayerChangeAnim(0);
        this.showAnimation.simple(50, (count, perc) => {
            this.setLayerChangeAnim(perc);
        }, () => {
            this.setLayerChangeAnim(1);
            // this.minimapLayout.hideAll();
            this.statLayout.hideAll();
            // this.listLayout.hideAll();
            this.hide();
            if (callback) callback();
        });
    }

    hide() {
        this.checkAnimation.stop();
        // this.listLayout.hide();
        this.statLayout.hide();
        this.minimapLayout.hide();
        this.hideAllIcon();
    }

    showAnim(callback?: Function) {
        this.setLayerChangeAnim(1);
        this.show();
        this.showAnimation.simple(50, (count, perc) => {
            this.setLayerChangeAnim(1 - perc);
        }, () => {
            if (callback) callback();
            this.setLayerChangeAnim(0);
        });
        this.minimapLayout.showAll();
        this.statLayout.showAll();
        // this.listLayout.showAll();
    }

    setLayerChangeAnim(perc) {
        let opacity = 1 - perc;
        let easePerc = this.curve.ease(perc);
        this.minimapLayout.setOpacity(opacity);
        this.minimapLayout.setScreenPosition({ right: easePerc * 100 + this.screenMargin, bottom: this.screenMargin });

        this.statLayout.setOpacity(opacity);
        this.statLayout.setScreenPosition({ left: easePerc * 100 + this.screenMargin, bottom: this.screenMargin });

        // this.listLayout.setOpacity(opacity);
        // this.listLayout.setScreenPosition({ right: easePerc * 100 + this.screenMargin, top: this.screenMargin });
    }

}
